import {CampaignType} from '../campaigns.types';

function isVideoCampaign(campaignType: CampaignType) {
  return [
    CampaignType.VideoAds,
    CampaignType.InteractiveVideoAds,
    CampaignType.FacebookVideoAds,
    CampaignType.MockSocial,
  ].includes(campaignType);
}

export default isVideoCampaign;
